import type { ComponentProps } from "react";
import React from "react";

import { cn } from "@/lib/helpers/cn";
import { Button2 } from "@/ui2/atoms/Button";
import { getAutomationDataAttr } from "@/utils/automationUtils";
import dayjs from "dayjs";

type AppointmentButtonProps = {
  isSelected: boolean;
  className?: string;
  startTime: string;
  endTime: string;
} & ComponentProps<typeof Button2>;

export const AppointmentButton = ({
  isSelected,
  className,
  startTime,
  endTime,
  ...props
}: AppointmentButtonProps) => {
  const formattedStartTime = dayjs(startTime, "HH:mm");
  const displayStartTime = formattedStartTime.format("h:mm");
  const formattedEndTime = dayjs(endTime, "HH:mm");
  const displayEndTime = formattedEndTime.format("h:mm a");

  const durationISO = dayjs.duration(formattedEndTime.diff(formattedStartTime)).toISOString();

  return (
    <Button2
      size="sm"
      variant="blank"
      /** TODO: Find better way to ignore bootstrap global styles  */
      className={cn(
        `tw:!text-3.5 body-sm tw:min-w-31.25 tw:!rounded-md tw:border tw:py-1 tw:!leading-5`,
        isSelected &&
          "tw:border-transparent tw:bg-fill-bright-purple-primary tw:*:text-text-on-accent",
        !isSelected && "tw:border-stroke-quaternary tw:bg-layer-floor-1 tw:text-text-secondary",
        className,
      )}
      /** This aria attribute is required for e2e tests */
      aria-pressed={isSelected}
      {...getAutomationDataAttr(`appointment-time-slot-${startTime}-${endTime}`)}
      {...props}
    >
      <time dateTime={durationISO}>
        {displayStartTime}–{displayEndTime}
      </time>
    </Button2>
  );
};
